import { EntityTable } from '@/features/admin/EntityTable';
import { Badge } from '@/components/ui/Badge';

export function ItemModelsPage() {
  return (
    <EntityTable
      title="Modelos de Item"
      subtitle="Catálogo do tipo de instrumento (SKU, material, compatibilidade térmica, custo)"
      endpoint="/v1/item-models"
      queryKey="item-models"
      columns={[
        { key: 'sku', label: 'SKU', className: 'font-mono text-xs' },
        { key: 'name', label: 'Nome' },
        { key: 'category', label: 'Categoria' },
        { key: 'raw_material', label: 'Material' },
        {
          key: 'thermal', label: 'Térmica',
          render: (r: any) => (
            <div className="flex flex-wrap gap-1">
              {r.steam_compatible ? <Badge tone="info">Vapor</Badge> : null}
              {r.plasma_compatible ? <Badge tone="brand">Plasma</Badge> : null}
              {r.accepts_thermal_wash ? <Badge tone="success">Termo</Badge> : null}
            </div>
          ),
        },
        {
          key: 'default_max_cycles', label: 'Ciclos máx.',
          render: (r: any) => r.default_max_cycles ?? '—',
          className: 'text-right tabular-nums',
        },
      ]}
      fields={[
        { name: 'sku', label: 'SKU', type: 'text', required: true },
        { name: 'name', label: 'Nome', type: 'text', required: true },
        { name: 'category', label: 'Categoria', type: 'text', placeholder: 'Ortopédico, Cardio etc.' },
        { name: 'manufacturer', label: 'Fabricante', type: 'text' },
        { name: 'reference', label: 'Referência fab.', type: 'text' },
        {
          name: 'raw_material', label: 'Material', type: 'select', required: true,
          options: [
            { value: 'STAINLESS_STEEL', label: 'Aço inox' },
            { value: 'TITANIUM', label: 'Titânio' },
            { value: 'TUNGSTEN', label: 'Tungstênio' },
            { value: 'POLYMER', label: 'Polímero' },
            { value: 'OTHER', label: 'Outro' },
          ],
        },
        { name: 'complex_conformation', label: 'Conformação complexa (lúmen, articulado)', type: 'checkbox' },
        { name: 'accepts_thermal_wash', label: 'Aceita lavagem termo-desinfectora', type: 'checkbox', defaultValue: true },
        { name: 'steam_compatible', label: 'Vapor', type: 'checkbox', defaultValue: true },
        { name: 'plasma_compatible', label: 'Plasma H2O2', type: 'checkbox' },
        { name: 'default_max_cycles', label: 'Ciclos máx. (padrão)', type: 'number', min: 0 },
        { name: 'weight_kg', label: 'Peso (kg)', type: 'number', step: 0.001 },
        { name: 'replacement_cost_cents', label: 'Custo de reposição (centavos)', type: 'number', min: 0 },
      ]}
    />
  );
}
